import { DeploymentStageName, LogLevel, TargetUserGroup } from '@trustedshops/tswp-core-common';

export const environment = {
  production: true,
  name: DeploymentStageName.QA,
  targetGroup: TargetUserGroup.Employees,
  pageTitle: 'eTrusted Control Centre',
  apis: {
    plugins: 'https://app-api.etrusted.site/v0'
  },
  diagnostics: {
    logging: {
      logLevels: [
        LogLevel.Warning,
        LogLevel.Error,
        LogLevel.Fatal
      ],
      filters: [],
      sentry: {
        environment: 'qa',
        logLevels: [
          LogLevel.Error,
          LogLevel.Fatal
        ],
        dsn: 'https://2261940b9ac14057bbc6880eeeedd925@o128203.ingest.sentry.io/5631748',
        browserTracingOrigins: [
          'localhost:6860',
          'employees-qa.trustedshops.com',
          'employees-api-qa.trustedshops.com'
        ],
        sentryConfig: {
          maxBreadcrumbs: 10
        }
      },
      instana: {
        logLevels: [
          LogLevel.Error,
          LogLevel.Fatal,
        ],
        allowedOrigins: [],
        browserTracingOrigins: [],
        reportingUrl: 'https://eum-blue-saas.instana.io',
        key: 'UK4fSW93Q2G6EAvODUAL_g',
        scriptUrl: 'https://eum.instana.io/1.8.1/eum.min.js',
      },
    }
  },
  authorization: {
    keycloakUrl: 'https://sso-qa.trustedshops.com/auth',
    clientId: 'tswp-carrier-employees',
    realm: 'ts-sso-QA',
    sessionVerificationType: 'check-sso',
    silentCheckSsoRedirectUri: '/assets/authentication/token-proxy.html'
  },
  layout: {
    resources: {
      heliosUri: 'https://employees-qa.trustedshops.com/helios.css',
      heliosIconUri: 'https://cdn-qa.trustedshops.com/helios/helios-icons/1.7.20/raw/'
    }
  },
  storage: {
    plugins: {
      rootPath: 'https://employees-qa.trustedshops.com/plugins'
    }
  }
};
